module.exports = __webpack_public_path__ + "img/train.32e4f312.svg";